import React from 'react';

const WorkStatusIcon = ({ size, color }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      id="work"
    >
      <path fill="none" d="M0 0h24v24H0V0z"></path>
      <path 
        d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM10 4h4v2h-4V4zm10 15H4V8h16v11z"
        fill={color || 'currentColor'}
      ></path>
    </svg>
  );
};

WorkStatusIcon.defaultProps = {
  size: 18,
  color: 'currentColor'
};

export default WorkStatusIcon;

